<template>

  <v-container fluid>
    
    <!-- 이미지 크롭 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" @keydown.esc="crop_dialog_land = false" v-model="crop_dialog_land" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="crop_dialog_land = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">
              <vueCropper
                ref="cropper_land"
                :img="imgSrc"
                :outputType="option.outputType"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :centerBox="option.centerBox"
                :high="option.high"
                :infoTrue="option.infoTrue"
                :maxImgSize="option.maxImgSize"
                :enlarge="option.enlarge"
                :mode="option.mode"
                :limitMinSize="option.limitMinSize"
                />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" @click="crop_dialog_land = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 추가버튼 + 다이얼로그 -->
    <v-row>
    <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
      <v-card class="dialog_round pa-10">

        <v-row dense align="center">
          <v-col cols="11" md="11" sm="11" xs="11">
            <span class="dialog_title">{{ dialogTitle }}</span>
          </v-col>
          <v-col cols="1" md="1" sm="1" xs="1">
            <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>

        <v-row dense justify="center">
          <v-col cols="12" md="12" sm="12" xs="12">
            <div style="background:#4e6ef7;height:2px;" />
          </v-col>
        </v-row>

        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-text-field v-model="editedItem.TITLE" label="제목" single-line></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-textarea counter="100" color="red" v-model="editedItem.DESC" :label="$t('adminbanner_label1')"
                value="" outlined :rules="[ v => (v.length <= 100) || $t('adminbanner_label2') ]" ></v-textarea>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-select v-model="editedItem.STATE" :items="STATELIST" :label="$t('adminbanner_col3')" 
                  :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"
                  />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <label>{{$t("adminbanner_label3")}}</label>
              </v-col>
            </v-row>
            <v-row>
              <v-img
                :src="editedItem.IMAGE"
                height="100" contain aspect-ratio="1"
                >
              </v-img>
            </v-row>
            <v-row>
              <v-col md="12" sm="12" xs="12">
                <v-file-input accept="image/*" :label="$t('adminbanner_label4')" v-model="uploadFile" @change="changefile"></v-file-input>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-select v-model="editedItem.TYPE" :items="TYPELIST" :label="$t('adminbanner_label5')" 
                :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" @change="linktypechange"
                  />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <template v-if="editedItem.TYPE == 1">
                  <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
                </template>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">

                <template v-if="editedItem.TYPE == 1 && SEARCH_COM_IDX > 0">
                  <eventdialog  :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
                </template>

                <template v-else-if="editedItem.TYPE == 2">
                  <noticedialog @callback="noticesearchcb"></noticedialog>
                </template>

              </v-col>
            </v-row>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <template v-if="editedItem.TYPE == 0">
                  <v-text-field v-model="editedItem.TYPE_URL" :label="$t('adminbanner_label6')" single-line></v-text-field>
                </template>
                <template v-else-if="editedItem.TYPE == 1">
                  <v-text-field v-model="editedItem.TYPE_URL" :label="$t('adminbanner_label7')" disabled single-line></v-text-field>
                </template>
                <template v-else-if="editedItem.TYPE == 2">
                  <v-text-field v-model="editedItem.TYPE_URL" :label="$t('adminbanner_label8')" disabled single-line></v-text-field>
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12" sm="12" xs="12">
                <v-menu
                  v-model="start_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.STARTDATE"
                      :label="$t('adminbanner_label9')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.STARTDATE" @input="start_date = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
                </v-menu>                    
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12" sm="12" xs="12">
                <v-menu
                  v-model="end_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.ENDDATE"
                      :label="$t('adminbanner_label10')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.ENDDATE" @input="end_date = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
                </v-menu>                    
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center">
          <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_cancel")}}</v-btn>
          <v-btn class="dialog_btn" rounded large @click="save">{{ editedIndex == -1 ? $t('common_insert') : $t('common_edit') }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>  
    </v-row>

    <v-row dense align="center">

      <v-col cols="12" md="5" sm="12" xs="12" class="pa-0">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      
      <!-- 검색어 -->
      <v-col cols="12" offset-md="2" md="3" sm="12" xs="12" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details          
          />
      </v-col>

      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn width="94%" class="search_btn_freesize"  elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>

      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn width="94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>

  </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >

        <template v-slot:header.IMAGE>
          <label class="cheader_normal" >{{$t("adminbanner_col1")}}</label>
        </template>
        <template v-slot:header.TITLE>
          <a :class="sort_name=='TITLE'?'cheader_sortselect':'cheader_sort'" @click="customsort('TITLE')">{{$t("adminbanner_col2")}}</a>
        </template>
        <!-- 
        <template v-slot:header.DESC>
          <a :class="sort_name=='DESC'?'color:red':'cheader_sort'" @click="customsort('DESC')">설명</a>
        </template>
        -->
        <template v-slot:header.STATE_NAME>
          <a :class="sort_name=='STATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE_NAME')">{{$t("adminbanner_col3")}}</a>
        </template>
        <template v-slot:header.TYPE_NAME>
          <a :class="sort_name=='TYPE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('TYPE_NAME')">{{$t("adminbanner_col4")}}</a>
        </template>
        <!-- 
        <template v-slot:header.TYPE_URL>
          <a :class="sort_name=='TYPE_URL'?'cheader_sortselect':'cheader_sort'" @click="customsort('TYPE_URL')">링크</a>
        </template>
        -->
        <template v-slot:header.STARTDATE>
          <a :class="sort_name=='STARTDATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('STARTDATE')">{{$t("adminbanner_col5")}}</a>
        </template>
        <template v-slot:header.ENDDATE>
          <a :class="sort_name=='ENDDATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('ENDDATE')">{{$t("adminbanner_col6")}}</a>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("adminbanner_col7")}}</label>
        </template>


        <!-- 특정 컬럼 커스텀 처리 -->
        <template v-slot:item.IMAGE="{ item }">
          <v-row justify="center">
            <v-img :src="item.IMAGE" height="80" width="200" contain/>
          </v-row>
        </template>
        <template v-slot:item.TITLE="{ item }">
          <template v-if="item.TITLE.length > 30">
            <td>{{ item.TITLE.substring(0, 30) + "..." }}</td>
          </template>
          <template v-else>
            <td>{{ item.TITLE }}</td>
          </template>
        </template>     
        <!-- 액션처리 - 아이템 슬롯을 재정의 할 수 있지만 기본값이 반응형에 더 최적화 되어있다. -->
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn  icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>

import 'cropperjs/dist/cropper.css';
import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리
export default {
    components:{
      //draggable,
      VueCropper
    },

    data: () => ({
      
      //파일 업로드
      uploadFile : null,

      selectFile:null,
      crop_dialog_land: false,
      imgSrc:'',
      ratio: 16/9,

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          TITLE:'',
          IMAGE:'',
          STATE:1, 
          STARTDATE: new Date().toISOString().substr(0, 10),
          ENDDATE: new Date().toISOString().substr(0, 10),
      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '이미지',  value: 'IMAGE', sortable: false, align:'center', width:100},
        {text: '제목',    value: 'TITLE', sortable: false, align:'center', width:200},
        //{text: '설명',    value: 'DESC', sortable: false, align:'center', width:200},
        {text: '상태',    value: 'STATE_NAME', sortable: false, align:'center', width:80},
        {text: '연결',    value: 'TYPE_NAME', sortable: false, align:'center', width:80},
        //{text: '링크',    value: 'TYPE_URL', sortable: false, align:'center', width:80},
        {text: '시작일',    value: 'STARTDATE', sortable: false, align:'center', width:120 },
        {text: '종료일',    value: 'ENDDATE', sortable: false, align:'center', width:120 },
        //{text: '등록일',    value: 'REG_DATE', sortable: false, align:'center', width:200 },
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center', width:100}
      ],
      itemList: [],

      sort_name: 'REG_DATE',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어


      //한 페이지 ROW 개수 설정
      pagerow : 10,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'10', VALUE:10}
        , {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
         
      //추가 변수들
      STATELIST: [
          {name:'비활성', name2:"Disable", value:0}
        , {name:'활성', name2:"Enable",   value:1}
      ],
        
      TYPELIST: [
          {name:'URL링크', name2:"URL Link",   value:0}
        , {name:'행사링크', name2:"Event Link",   value:1}
        , {name:'공지링크', name2:"Notice Link",   value:2}
      ],

      start_date : false,
      end_date : false,

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',


      //신규 크롭 파라메터
      option: {
        img: "",
        size: 1,
        full: true,
        outputType: "png",
        canMove: true,
        fixed: true,          //크롭박스 비율 고정
        fixedNumber: [16,9],  //크롭박스 비율
        fixedBox: false,      //true면 크롭박스 크기 조절 안됨
        original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:400,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:400,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
				enlarge: 1,
        mode: 'contain',
        maxImgSize: 1500,
        limitMinSize: [300, 300]
      },         

    }),

    mounted(){

      if(this.$session.get("GRADE") < 99){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    methods: {

      linktypechange(){
        this.editedItem.TYPE_URL = "";
      },

      //배너 이미지 선택시
      changefile(){

        //파일명 백업
        this.selectFile = this.uploadFile.name;

        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          this.crop_dialog_land = true;
          this.imgSrc = event.target.result;  //이게 blob데이터
          //this.$refs.cropper_land.replace(event.target.result);
        }
        reader.readAsDataURL(this.uploadFile);  //비동기로 파일을 읽어서

      },

      //이미지 크롭시
      cropimg(){
        this.$refs.cropper_land.getCropBlob(blob=>{
          this.crop_dialog_land = false;
          this.uploadFile = blob;
          this.$refs.cropper_land.getCropData(data=>{
            this.editedItem.IMAGE = data; //이미지뷰 미리보기용
          });
        })
      },

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.editedItem.TYPE_URL = "event://"+val1.IDX;
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.editedItem.TYPE_URL = "";
        }
      },

      //검색조건 업체 설정
      noticesearchcb(val1){
        if(val1.TITLE.length > 0){
          this.editedItem.TYPE_URL = "notice://"+val1.IDX;
        }else{
          this.editedItem.TYPE_URL = "";
        }
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = '';
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
        }
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = '';
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
      },


      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      //조회
      loadpage(p){

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/BannerList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , COM_IDX: "0"
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
              
                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                this.itemList.splice(0, this.itemList.length);   //데이터 초기화
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.uploadFile = null;
        }, 300)
      },

      //추가 및 수정
      save () {

        if(this.editedItem.TITLE  == undefined || this.editedItem.TITLE.length < 1){
          //alert("제목을 입력하세요");
          this.$alert(this.$t('adminbanner_msg1'));
          return;
        } 
        if(this.editedItem.TITLE.length > 50){
          this.$alert(this.$t('adminbanner_msg2'));
          return;
        } 

        if(this.editedItem.DESC  == undefined || this.editedItem.DESC.length < 1){
          this.$alert(this.$t('adminbanner_msg3'));
          return;
        } 
        if(this.editedItem.DESC.length > 100){
          this.$alert(this.$t('adminbanner_msg4'));
          return;
        } 

        if(this.editedItem.IMAGE == undefined || this.editedItem.IMAGE.length < 1){
          if(this.uploadFile == undefined || this.uploadFile.length < 1){
            this.$alert(this.$t('adminbanner_msg5'));
            return;
          } 
        }

        const temp_start = new Date(this.editedItem.STARTDATE)
        const temp_end   = new Date(this.editedItem.ENDDATE)
        if(temp_start > temp_end){
          this.$alert(this.$t('adminbanner_msg6'));
          return;
        }

        if(this.editedItem.TYPE == undefined || this.editedItem.TYPE == null){
          this.$alert(this.$t('adminbanner_msg7'));
          return;
        }

        if(this.editedItem.TYPE == 1){
          if(this.SEARCH_COM_IDX == undefined || this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_company'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t("common_select_event"));
            return;
          }
        }

        if(this.editedItem.TYPE_URL == undefined || this.editedItem.TYPE_URL == null || this.editedItem.TYPE_URL.length < 1){
          this.$alert(this.$t('adminbanner_msg8'));
          return;
        }



        if (this.editedIndex > -1) {

          //수정
          this.loading = true;

          const formData = new FormData();
          formData.append("FOLDER",     "banner");
          formData.append("TITLE",      this.editedItem.TITLE);
          formData.append("DESC",       this.editedItem.DESC);
          formData.append("STATE",      this.editedItem.STATE);
          formData.append("TYPE",       this.editedItem.TYPE);
          formData.append("TYPE_URL",   this.editedItem.TYPE_URL);
          formData.append("STARTDATE",  this.editedItem.STARTDATE);
          formData.append("ENDDATE",    this.editedItem.ENDDATE);
          formData.append("ADMIN_IDX",  this.$session.get("ADMIN_IDX"));
          formData.append("IDX",        this.editedItem.IDX);


          const file = new File([this.uploadFile], "banner.jpg");
          formData.append("customfile", file);
          this.$http.post(this.$host+'/api/BannerUpdate', formData, {
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loading = false;
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                this.$alert(this.$t("common_edit_fail"));
              }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            //this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });

        }else{
          //신규
          this.loading = true;
          const formData = new FormData();
          formData.append("FOLDER",     "banner");
          formData.append("TITLE", this.editedItem.TITLE);
          formData.append("DESC", this.editedItem.DESC);
          formData.append("STATE", this.editedItem.STATE);
          formData.append("TYPE", this.editedItem.TYPE);
          formData.append("TYPE_URL", this.editedItem.TYPE_URL);
          formData.append("STARTDATE", this.editedItem.STARTDATE);
          formData.append("ENDDATE", this.editedItem.ENDDATE);
          formData.append("ADMIN_IDX", this.$session.get("ADMIN_IDX"));

          const file = new File([this.uploadFile], "banner.jpg");
          formData.append("customfile", file);

          this.$http.post(this.$host+'/api/BannerInsert', formData, {
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_insert_msg")).then(()=>{
                  this.loading = false;
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('common_reg_fail'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            //this.loading = false;
            this.$alert(this.$t('common_reg_fail'));
          });
        }

        this.close()  //팝업닫기
      },      

      //검색버튼 클릭
      search_run(){
        this.loadpage(1);
      },

      //신규 추가
      newinsert(){
        this.dialogTitle  = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem   = Object.assign({}, this.defaultItem)
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          
          this.loading = true;
          this.$http.post(this.$host+'/api/BannerDelete',{
                IDX:item.IDX
              , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      
        });

      },

    },
  
}
</script>



<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>



</style>